var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplefiligreeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2bb62216-5893-45d5-b3f8-dec6193aa0d4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.64 68.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V68.08H90.64V0H0ZM3,65.08V3H87.64v62.08H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.62,44.14c-.45,0-.9-.17-1.24-.51l-21.98-21.98-26.37,26.37c-.34,.34-.79,.51-1.24,.51s-.9-.17-1.24-.51c-.68-.68-.68-1.79,0-2.48l5.33-5.33-8.04-8.04-10.59,10.59c-.34,.34-.79,.51-1.24,.51s-.9-.17-1.24-.51c-.68-.68-.68-1.79,0-2.48l11.83-11.83c.68-.68,1.79-.68,2.48,0l9.28,9.28,19.79-19.79c.68-.68,1.79-.68,2.48,0l23.22,23.22c.68,.68,.68,1.79,0,2.48-.34,.34-.79,.51-1.24,.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplefiligreeImage);
export default __webpack_public_path__ + "static/media/simple filigree - image.435bb429d9f526ce1e5a1dacf19369ed.svg";
export { ForwardRef as ReactComponent };